// Abre o novo chat do Pravaler
$(".webchat-start").on("click", function() {
		$('.abrir-chat').trigger('click');
});

